import script from "./Markers.vue?vue&type=script&lang=js"
export * from "./Markers.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__